<app-page>
    <app-business [businessId]="businessId"></app-business>
</app-page>
